/*(function ($) {
  $(document).ready(function() {
    console.log('woocommerce-wishlist')
    $('body').on('added_to_wishlist', function (e, t, el_wrap) {
      console.log('added_to_wishlist', e, t, el_wrap)
    })

    $(document).on('yith_wcwl_init_after_ajax', function () {
      console.log('yith_wcwl_init_after_ajax')
    })

  })
})(jQuery)*/
